import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription, take } from 'rxjs';
import { CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ValidationService } from 'src/app/core/services/validation.service';
import { environment } from 'src/environments/environment';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import * as moment from 'moment';
import { UserService } from 'src/app/core/services/user.service';
import { WalletConnectDialogComponent } from '../../../wallet-connect-dialog/wallet-connect-dialog.component';
import { Web3Service } from 'src/app/core/services/web3.service';
import { MatDialog } from '@angular/material/dialog';
import { LandingPageService } from 'src/app/core/services/landing-page.service';
import { or } from '@rxweb/reactive-form-validators';
declare let $: any;
@Component({
  selector: 'app-home-v4',
  templateUrl: './home-v4.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { noPause: true } }
  ],
  // host: {
  //   '(document:click)': 'outsideClick($event)',
  // },
  styleUrls: ['./home-v4.component.scss']
})
export class HomeV4Component implements OnInit {
  isLoggedIn:boolean=false;
  walletID:string="";
  isWalletDialogVisible : boolean = false;
  scrollInterval;
  selectedIndex = 1;
  indicators = true;
  scrollPosition = 0;
  scrollpos = true;
  numberOfImagesInView = 4;
  autoScrollBy = document.documentElement.clientWidth + 60;
  maxBannerList: any = 20;
  myInterval = 40000;
  timezoneVal;
  myListResp: any;
  bannerList = [];
  eventList: any = {};
  sliderArray: any = [];
  activeChannel: any = {};
  channelarray: any = [];
  isLoadingEvent: boolean = false;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  myListInfoSubscription: Subscription;
  getEventData: any;
  contactInformtionForm: FormGroup;
  deviceInfo: any;
  assets_url = environment.assets_url;
  endDate: any;
  todayDate: any;
  totalSeconds: number = 0; // Difference between todays date and sales end date
  days: number = 0;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  displayTime: any;
  videoInterval: any;
  showTimer: boolean = true;
  showPlayBtn: boolean = true;
  featured_audios: any = {}
  featured_charities: any = {}
  featured_past_events: any = {}
  featured_videos: any = {}
  default_image: string = DEFAULT_IMAGE.IMAGE_1;
  nft_raw_data: any;
  timerMessage: any;
  featured_channels = [];
  socialShareClick: boolean = false;

  // Multiple timers
  displayMultipleTime = [];
  showTimerIndex = null;

  constructor(private ngxLoader: NgxUiLoaderService, private router: Router,
    private commanService: CommanSubscribeService, private web3service :Web3Service, private storageService: StorageService, private formBuilder: FormBuilder, private toastr: ToastrService, private userService: UserService, private dialog:MatDialog, private route: ActivatedRoute, private landingPageService: LandingPageService) { }
  ngOnInit() {
    localStorage.removeItem("WalletId");
    // document.addEventListener("visibilitychange", this.handleVisibilityChange);
    let device = this.commanService.getMobileOperatingSystem();
    this.deviceInfo = device;
    this.timezoneVal = this.userService.getTimezone();
    let todayLocalTime = moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
    this.todayDate = moment.utc(todayLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
    // this.todayDate = moment(moment().format("YYYY-MM-DD hh:mm A")).tz(this.timezoneVal);
    // this.todayDate= moment(this.todayDate).format("YYYY-MM-DD HH:mm:ss")
    // moment.utc(this.bannerList[index].sale_end_time).local().format("YYYY-MM-DD HH:mm:ss");   
    // this.todayDate = moment(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal); //.valueOf();

    setTimeout(() => {
      this.loadAdsScript();
    }, 1000);
    this.buildcontactInformtionForm();
    this.userInfo = this.commanService.userInfo;
    this.userInfoSubscription = this.commanService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.getEvents();
    if (this.userInfo && this.userInfo.id)
      this.getList();
    if (this.userInfo && Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_guest) {
      this.router.navigate(['/userhome']);
    }
    if (this.userInfo && this.userInfo.id) {
      let isSocialLogin = this.storageService.getItem("isSocialLogin");
      if (isSocialLogin) {
        this.getEventData = this.storageService.getItem('eventInfo');
        if (this.getEventData && this.getEventData.id) {

        }
      }
    }

    if (this.userInfo && this.userInfo.id) {
      let isSocialLogin = this.storageService.getItem("isSocialLogin");
      if (isSocialLogin) {
        this.getEventData = this.storageService.getItem('eventInfo');
        if (this.getEventData && this.getEventData.id) {
          this.goToEventReg(this.getEventData);
        }
      }
    }

    // if(this.userInfo && this.userInfo.id){
    //   this.isLoggedIn = true;
    //   this.connectToWallet();
    //   this.walletID = localStorage.getItem("WalletId");
    // }

    this.myListResp = this.commanService.myListInfo
    this.myListInfoSubscription = this.commanService.getMylistData().subscribe(response => {
      this.myListResp = response;
      if (this.myListResp.length > 0 && this.bannerList.length > 0) {
        this.myListResp.forEach(list => {
          this.bannerList.forEach((event, index) => {
            if (Number(event.id) == Number(list.stream_video_id) && list.ticket_ids.length>0) {
              this.bannerList[index].isTicketPurchased = true;
              this.bannerList[index].ticket_key = list.ticket_key;
            }
          });
        });
      }
    });



    if (this.deviceInfo === 'web') {
      this.scrolling();
      this.imageScroll();
    }
    $('#myCarousel1').on('slide.bs.carousel', (e) => {
      this.isShown = false;
      this.totalSeconds = 0;
      if (this.displayMultipleTime[e.to + 1]['displayTimer']) {
        clearInterval(this.displayMultipleTime[e.to + 1]['displayTimer']);
      }
      //this.clearTimer(e.to + 1);
      this.startTimer(e.to + 1);
      this.calculateMultipleTimes(e.to + 1);
      this.selectedIndex = e.to + 1;
    })

    $('#myCarousel3').on('slide.bs.carousel', (e) => {
    this.pauseVideo();
  });
  
  // Handle mobile banner carousel - FIX FOR FREEZING
  $('#myCarousel1').on('slide.bs.carousel', (e) => {
    const toIndex = e.to;
    // Ensure displayTimerIndex is valid
    if (toIndex >= 0 && toIndex < this.displayMultipleTime.length) {
      this.displayTimerIndex = toIndex;
      this.isShown = false;
      this.socialShareClick = false;
    }
  });
  
  $('#myCarousel1').on('slid.bs.carousel', (e) => {
    // After slide completes, update timer
    const toIndex = e.to;
    if (toIndex >= 0 && toIndex < this.displayMultipleTime.length) {
      this.displayTimerIndex = toIndex;
      // Use setTimeout to prevent blocking
      setTimeout(() => {
        if (this.displayMultipleTime[toIndex]) {
          this.totalSeconds = 0;
          if (this.displayMultipleTime[toIndex]['displayTimer']) {
            clearInterval(this.displayMultipleTime[toIndex]['displayTimer']);
          }
          this.startTimer(toIndex);
          this.calculateMultipleTimes(toIndex);
        }
      }, 100);
    }
  });

    this.nft_raw_data = [
      {
        org: "DEATHROWNFT",
        title: "Dogg on it: Death Row Mixtape Vol. 1",
        content: "Bacc on Death Row For the first time ever, Snoop Dogg is dropping a mixtape as an NFT.First edition, Dogg on it.The mixtape includes beats, acapellas, full songs, all from artists from around the world.All Death Row.",
        image: "https://dev1-uploads.arevea.com/thumbnail/1643272109752.webp"

      },
      {
        org: "ORANGEARMY",
        title: "Dogg on it: Death Row Mixtape Vol. 1",
        content: "Bacc on Death Row For the first time ever, Snoop Dogg is dropping a mixtape as an NFT.First edition, Dogg on it.The mixtape includes beats, acapellas, full songs, all from artists from around the world.All Death Row.",
        image: "https://dev1-uploads.arevea.com/org_1758/thumbnail/1650352037759.jpg"

      },
      {
        org: "HYDERABADNFT",
        title: "Dogg on it: Death Row Mixtape Vol. 1",
        content: "Bacc on Death Row For the first time ever, Snoop Dogg is dropping a mixtape as an NFT.First edition, Dogg on it.The mixtape includes beats, acapellas, full songs, all from artists from around the world.All Death Row.",
        image: "https://dev1-uploads.arevea.com/thumbnail/1643272109752.webp"

      }

    ]
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (returnUrl && (!this.userInfo || !this.userInfo.signedIn)) {
      setTimeout(() => {
        this.landingPageService.openConsumerSignIn();
      }, 100);
    }
  
  }


  async getAccountAddress() {
    let accounts;
    accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
    console.log(">>>>accounts", accounts);
    this.walletID = accounts[0];
    localStorage.setItem("WalletId",accounts[0]);
    console.log('>>>>accounts',this.walletID);
  }

  async connectToWallet() {
      this.walletID = localStorage.getItem("WalletId");
      this.web3service.setNetwork(environment.clientDetails.network_name);
      await this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
        console.log("isWeb3",isweb3);
        if (isweb3 === 'connected') {
          this.web3service.setContract();
          this.web3service.connectAccount().then(async (res) => {
            console.log("connect account response",res);
            await this.getAccountAddress();
            this.commanService.getAccountBalance(this.walletID);
          })
        }
      }).catch((e) => {
        console.log(e)
        if(this.isLoggedIn && !this.isWalletDialogVisible){
          console.log("isLoggedIn",this.isLoggedIn);
          this.isWalletDialogVisible=true;
        // this.dialog.open(WalletConnectDialogComponent,{
        //   panelClass : "app-consumer-sign-in",  
        //   hasBackdrop : true,
        //   disableClose : true,
        //   data : {
        //     text : "Please install MetaMask to claim tokens"
        //   }
        // });
      }
      })
  }

    
  scrolling() {
    this.scrollInterval = setInterval(() => {
      let scrolldiv = document.getElementById('event-container');
      this.isShown = false;
      if (this.selectedIndex === this.bannerList.length - 1) {
        this.selectedIndex = this.bannerList.length == 1 ? 0 : 1;
        this.scrollPosition = 0;
        scrolldiv.scrollTo(0, 0)
        this.totalSeconds = 0;
        if (this.displayMultipleTime[this.selectedIndex]['displayTimer']) {
          clearInterval(this.displayMultipleTime[this.selectedIndex]['displayTimer']);
        }
        //this.clearTimer(this.selectedIndex);
        this.startTimer(this.selectedIndex);
        this.calculateMultipleTimes(this.selectedIndex);
      }
      else {
        this.selectedIndex = this.selectedIndex + 1;
        this.totalSeconds = 0;
        if (this.displayMultipleTime[this.selectedIndex]['displayTimer']) {
          clearInterval(this.displayMultipleTime[this.selectedIndex]['displayTimer']);
        }
        //this.clearTimer(this.selectedIndex)
        this.startTimer(this.selectedIndex);
        this.calculateMultipleTimes(this.selectedIndex);
        if (this.selectedIndex % this.numberOfImagesInView <= this.numberOfImagesInView && this.selectedIndex >= this.numberOfImagesInView) {
          // scrolldiv.scrollTo(this.autoScrollBy, 0)
          scrolldiv.scrollLeft += scrolldiv.clientWidth - (scrolldiv.clientWidth * 0.57);
        }
      }
    }, 14000);
  }

  over() {
    clearInterval(this.scrollInterval)
  }
  out() {
    this.scrolling()
  }

  myList = [];
  getList() {
    if (this.userInfo && this.userInfo.access_token) {
      let myInit = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: { userid: this.userInfo.id }
      }

      this.ngxLoader.start();
      API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.MY_LIST, myInit).then(response => {
        this.ngxLoader.stop();
        if (response.data.statusCode === '200' && response.data.Data) {
          // this.commanService.initSlider(".channels-images-slider3");
          response.data.Data.forEach(e => {
            e.image = e.video_banner_image ? e.video_banner_image : e.video_thumbnail_image;
            if (!e.image) {
              e.image = DEFAULT_IMAGE.IMAGE_1;
            }
            this.myList.unshift(e);
            this.commanService.sendMylistData(this.myList);
          })
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }

  timeUpdate(evt) {
  const target = evt.target as HTMLVideoElement;
  
  if (!target.paused) {
    $("#myCarousel3").carousel("pause");
    this.showPlayBtn = false;
  } else {
    $("#myCarousel3").carousel("cycle");
    this.showPlayBtn = true;
  }
  
  // Check if video has ended (with small buffer for timing issues)
  if (target.currentTime >= target.duration - 0.5) {
    $("#myCarousel3").carousel("next");
    target.currentTime = 0;
    target.pause();
    this.showPlayBtn = true;
  }
}

  playVideo(i, video) {
  const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
  (window as any).umami?.track(`Featured Video Played By - ${userId}`);
  const data = {
    actionType: "event",
    metaData: {
      title: "Featured Video Played",
      timeStamp: new Date().toISOString()
    },
    organizationId: this.commanService.slugInfo?.organizationId || null,
  }
  this.commanService.sendTriggeredEvent(data);
  
  let vid = <HTMLVideoElement>document.getElementById('bannerVideo' + i);
  if (vid) {
    this.showPlayBtn = false;
    
    // Pause carousel before playing video
    $("#myCarousel3").carousel("pause");
    
    this.getSignedURL(video.data.data.banner_video_url, (url) => {
      video.video_url = url;
      vid.src = url;
      
      // Add event listeners before loading
      vid.onloadeddata = () => {
        console.log('Video loaded successfully');
        vid.play().catch(error => {
          console.error('Error playing video:', error);
          this.showPlayBtn = true;
        });
      };
      
      vid.onerror = () => {
        console.error('Error loading video');
        this.showPlayBtn = true;
        $("#myCarousel3").carousel("cycle");
      };
      
      vid.load();
    });
  }
}

  pauseVideo() {
  for (let k = 0; k < this.featured_videos?.length; k++) {
    let vid = <HTMLVideoElement>document.getElementById('bannerVideo' + k);
    if (vid) {
      vid.pause();
      vid.currentTime = 0; // Reset to beginning
    }
  }
  this.showPlayBtn = true;
  $("#myCarousel3").carousel("cycle");
}

  buildcontactInformtionForm() {
    this.contactInformtionForm = this.formBuilder.group({
      user_email: [{ value: this.userInfo.email, disabled: false }, [Validators.required, ValidationService.emailValidator]],
    });
  }
  contactButton() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`contact-us-clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "contact-us-clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
    }
    this.commanService.sendTriggeredEvent(data);
    if (this.contactInformtionForm.valid) {
      this.router.navigate(['/contactus'], { queryParams: { email: this.contactInformtionForm.value.user_email } });
    } else {
      this.toastr.error("Please enter e-mail id");
    }
  }
  redirectTo(event, type) {
    if (type == 'schedule') {
      this.router.navigateByUrl(`${event?.channel_name}/event/schedule/${event.ticket_key}`);
    } else {
      if (event.stream_status == 'completed' && event.conversion_status == 'completed')
        this.router.navigate([`${event?.channel_name}/watch/` + event.ticket_key], { queryParams: { stage: event.id } });
      else
        this.router.navigate([`${event?.channel_name}/stream/` + event.ticket_key], { queryParams: { stage: event.id } });
    }
  }

  activeSlider(event) {
    this.bannerList[event].isShowImg = false;
    this.myInterval = this.bannerList[event].isBannerVideo ? 40000 : 20000;
    $('#video_block').show();
    $('#video_tag').show();
    setTimeout(() => {
      $('#videoIndexVal' + event).prop('muted', true);
      $('#videoIndexVal' + event).trigger('play');
      if (event == 0)
        $('#videoIndexVal' + (this.bannerList.length - 1)).trigger('pause');
      else
        $('#videoIndexVal' + (event - 1)).trigger('pause');
    }, 1000);
  }
  showBanner(e, index?) {
    e.isShowImg = true;
    this.myInterval = 20000;
    // e.isBannerVideo = !e.isBannerVideo;

    // this.playSelectedVideo(index);
  }
  selectImage(index) {
    this.selectedIndex = index;
    this.totalSeconds = 0;
    if (this.displayMultipleTime[index]['displayTimer']) {
      clearInterval(this.displayMultipleTime[index]['displayTimer']);
    }
    //this.clearTimer(index)
    this.startTimer(index);
    this.calculateMultipleTimes(index);
  }

  //startTimer(index?) {
  // this.displayTime = setInterval(() => {
  //   if (this.totalSeconds > 0) {
  //     this.days = Math.floor(this.totalSeconds / (3600*24));
  //     this.hours = Math.floor(this.totalSeconds % (3600*24) / 3600);
  //     this.minutes = Math.floor(this.totalSeconds % 3600 / 60);
  //     this.seconds = Math.floor(this.totalSeconds % 60);
  //     this.totalSeconds = this.totalSeconds - 1;
  //   } else {
  //     this.days = 0;
  //     this.hours = 0;
  //     this.minutes = 0;
  //     this.seconds = 0;
  //   }
  // }, 1000)
  //}

  clearTimer(index) {

    // let currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    // this.totalSeconds = moment.utc(currentDate,"YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    // let eventStartSeconds = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf() || 0;
    // let eventEndSeconds = moment.utc(this.bannerList[index].expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf() || 0;
    // let salesStartSeconds = moment.utc(this.bannerList[index].sale_start_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf() || 0;
    // let salesEndSeconds = moment.utc(this.bannerList[index].sale_end_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf() || 0;

    // if(this.totalSeconds < salesStartSeconds){            // If sales not started yet
    //   if(salesStartSeconds<eventStartSeconds){            
    //     this.timerMessage = "Sale starts in ..."          // Sale starts before event
    //     this.endDate = moment.utc(this.bannerList[index].sale_start_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    //   }else if(salesStartSeconds>eventStartSeconds){      // Event starts before sales
    //     this.timerMessage = "Event starts in ...";
    //     this.endDate = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    //   }
    // }
    // else if((this.totalSeconds > salesStartSeconds) && (this.totalSeconds < salesEndSeconds)){                    
    //   if(this.bannerList[index].isTicketPurchased){        // Sales started         
    //     this.timerMessage = "Event starts in ..."          // If ticket is purchased          // event started or not
    //     this.endDate = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    //   }else{                                            // If ticket is not purchased
    //     this.endDate = moment.utc(this.bannerList[index].sale_end_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    //     this.timerMessage = "Sale ends in ...";
    //   }
    // }
    // else if(this.totalSeconds > salesEndSeconds){          // If sales are ended
    //   if((eventEndSeconds>salesEndSeconds) && (eventStartSeconds>salesEndSeconds)){                 // Event not ended yet
    //     this.timerMessage = "Event ends in ..."
    //     this.endDate = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).valueOf();
    //   }else if(this.totalSeconds>eventEndSeconds){
    //     this.timerMessage = "Event ended"                 // Event ended
    //     this.showTimer = false;
    //   }
    // }
    //this.startTimer();
  }
  scrolled(evt) {
    let left = evt.target.scrollLeft;
    let width = evt.target.clientWidth;
    let scrollWidth = evt.target.scrollWidth;
    this.scrollPosition = 100 * left / (scrollWidth - width) - (0.126 * 100);
    if (this.scrollPosition < 0)
      this.scrollPosition = 0
  }
  loadAdsScript() {
    var t;

    var start = $('#myCarousel1').find('.active').attr('data-interval');
    t = setTimeout("$('#myCarousel1').carousel({interval: 14000});");
    $('#myCarousel1').on('slid.bs.carousel', function () {
      $('#myCarousel1').carousel({
        pause: false
      });
      clearTimeout(t);
      var i = $(this).find('.active').attr('data-interval');

      $('#myCarousel1').carousel({
        pause: false
      });
      t = setTimeout("$('#myCarousel1').carousel();", i - 1000);
    })
    $('.carousel-control-next').on('click', function () {
      clearTimeout(t);
      $('#myCarousel1').carousel({
        pause: false
      });
    });

    $('.carousel-control-prev').on('click', function () {
      clearTimeout(t);
      $('#myCarousel1').carousel({
        pause: false
      });
    });
  }
  session3 = [
    {
      img: this.assets_url + "website-home-v3/landing/Empowering_creators.svg",
      txt: "EMPOWERING CREATORS",
    }, {
      img: this.assets_url + "website-home-v3/landing/Monetize_Content.svg",
      txt: "MONETIZE CONTENT"
    }, {
      img: this.assets_url + "website-home-v3/landing/Building_Communities.svg",
      txt: "BUILDING COMMUNITIES"
    }
  ]
  session8 = [
    {
      img8: this.assets_url + "website-home-v3/landing/Concerts.png",
      txt: "CONCERTS"
    }, {
      img8: this.assets_url + "website-home-v3/landing/Festivals.png",
      txt: "FESTIVALS"
    }, {
      img8: this.assets_url + "website-home-v3/landing/Meet_Greet.png",
      txt: "MEET & GREET"
    }, {
      img8: this.assets_url + "website-home-v3/landing/Listening_Parties.png",
      txt: "LISTENING PARTIES"
    }
  ]
  session10 = [
    {
      img10: this.assets_url + "website-home-v3/landing/Talent.png",
      txt: "TALENT",
      link: "/talent"
    }, {
      img10: this.assets_url + "website-home-v3/landing/Venue.png",
      txt: "VENUES",
      link: "/venues"
    }, {
      img10: this.assets_url + "website-home-v3/landing/Promoter.png",
      txt: "PROMOTERS"
    }
  ]
  getEvents() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        'x-api-key': environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo?.access_token}`
      },
      response: true,
      body: {}
    }
    this.eventList.upcoming_events = [];
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_FEATURED_ITEMS, myInit).then(response => {
      if (response.data.statusCode === '200' && response.data.Data) {
        this.featured_audios = Array.isArray(response.data.Data.featured_audios) ? response.data.Data.featured_audios : [];
        this.featured_audios.sort((a,b)=>{
          if(a.data.display_order<b.data.display_order){
            return -1
          }if(a.data.display_order>b.data.display_order){
            return 1
          }
        })
        this.featured_charities = response.data.Data.featured_charities;
        this.featured_past_events = response.data.Data.featured_past_events
        this.featured_videos = response.data.Data.featured_videos;
        this.featured_videos.sort((a,b)=>{
          if(a.data.display_order<b.data.display_order){
            return -1
          }if(a.data.display_order>b.data.display_order){
            return 1
          }
        })
       
        this.featured_channels = response.data.Data.featured_channels;
        this.featured_past_events.map((event, i: number) => {
          if (event.data.data.media_files) {
            let media_data = {}
            let media_files = JSON.parse(event.data.data.media_files);
            Object.keys(media_files).forEach(element => {
              event.data.data[element] = media_files[element];
            });
          }
        })

      }
    });
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.EVENTS, myInit).then(response => {
      this.ngxLoader.stop();
      if (response.data.statusCode === '200' && response.data.Data) {
        this.commanService.initSlider(".channels-images-slider1");
        this.eventList = response.data.Data;
        this.channelarray = this.eventList.channels;
        this.commanService.sendUpcomingEvents(this.eventList.upcoming_events);

        if (this.eventList.upcoming_events && this.eventList.upcoming_events.length > 0) {
          this.eventList.upcoming_events.forEach(e => {
            e = e.stream_info;
            e.name = e.user_first_name + ' ' + e.user_last_name;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
            }
            if (!e.video_banner_image) {
              e.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
            }
            if ((this.bannerList.length < this.maxBannerList) && e.publish == 1) {
              e.org_publish_date_time = e.publish_date_time;
              let localTime = moment.utc(e.publish_date_time).toDate();
              if (e.selected_type == 'single_session_event')
                e.publish_date_time = moment(localTime).format('DD MMM YYYY, hh:mm A');
              else
                e.publish_date_time = moment(localTime).format('DD MMM YYYY');
              //e.publish_date_time = moment(e.publish_date_time).format("DD MMM YYYY hh:mm A");
              e.isEvent = "upcoming";
              if (e.stream_video_title == 'NHC 1') {
                e.stream_video_title = 'Jamaican All-Stars Carnival Special';
              }
              if (e.stream_video_title.includes('Jamaican All-Stars Carnival Special')) {
                let title = e.stream_video_title.split(" ");
                e.first_line = title[0] + ' ' + title[1];
                e.second_line = title[2] + ' ' + title[3];
              }
              if (!e.short_description) {
                e.short_description = "";
              }
              e.isBannerVideo = false;
              // e.banner_video_url = 'https://uploads-areveatv-dev.s3.us-west-2.amazonaws.com/banner-video/Copy-of-AREVEA_TV_JAS_TRAILER_LONGER-SPONSORED-40-secs-V3-4-5.mp4/1625670890664.mp4';
              if (e.banner_video_url) {
                const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                const match = e.banner_video_url.match(regExp);
                if (match && match[2].length === 11) {
                  // if (e.banner_video_url.includes('https://www.youtube.com')) {	
                  // e.banner_video_url = e.banner_video_url.replace('watch?v=', 'embed/');	
                  e.isYoutubeVideo = true;
                  // e.videoId = this.YouTubeGetID(e.banner_video_url) //video id	
                  // this.loadAPI(e);
                } else {
                  e.isYoutubeVideo = false;
                }
                e.isBannerVideo = true;
              }

              if (e.media_files) {
                let media_files = JSON.parse(e.media_files);
                Object.keys(media_files).forEach(element => {
                  e[element] = media_files[element];
                });
              }
              if (e.expected_end_date_time && e.org_publish_date_time
                && e.sale_start_time && e.sale_end_time) {
                // Today date
                // let todayLocalTime =   moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                // let convertedTodayLocalTime = moment.utc(todayLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
                // Event end date
                // let localEndDateTime = moment.utc(e.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                // let convertedLocalEndDateTime = moment.utc(localEndDateTime).local().format("YYYY-MM-DD HH:mm:ss");
                // Allow only events whose event end dates are not completed
                // if(moment(convertedLocalEndDateTime).diff(moment(convertedTodayLocalTime), 'seconds')>0){
                //   this.bannerList.push(e);
                // }
                e.removeFromDrop = true;
                this.bannerList.push(e);
              }
              e.url = `${e.slug}`;
            }
          });
        }
        if (this.eventList.albums && this.eventList.albums.length > 0) {
          let albumList = [];
          this.eventList.albums.forEach(e => {
            if (e.org_info) {
              e.stream_info.organization_logo = e.org_info.organization_logo;
              e.stream_info.organization_name = e.org_info.organization_name;
            }
            e = e.stream_info;
            e.isEvent = "albums";
            e.org_publish_date_time = e.publish_date_time;
            e.event_home_banner = e.video_banner_image = e.video_thumbnail_image;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = e.video_banner_image = e.event_home_banner = DEFAULT_IMAGE.IMAGE_1;
            }
            e.url = e.channel_name + "/album/" + e.vod_video_audio + "/" + e.slug;
            e.removeFromDrop = true;
            albumList.push(e);
          })
          this.bannerList = this.bannerList.concat(albumList);
        }
        if (this.eventList.products && this.eventList.products.length > 0) {
          let productList = [];
          this.eventList.products.forEach(e => {
            if (e.org_info) {
              e.organization_logo = e.org_info.organization_logo;
              e.organization_name = e.org_info.organization_name;
            }
            e.isEvent = "product";
            e.stream_video_title = e.data.name;
            e.org_publish_date_time = e.sale_start_date_time;
            e.expected_end_date_time = e.drop_end_date_time;
            e.expected_end_date_time_formated = e.drop_end_date_time.replaceAll('-', '/')
            if (e.data.media_url) {
              e.event_home_banner = e.video_banner_image = e.data.media_url[0];
            }
            if (!e.data.media_url) {
              e.video_thumbnail_image = e.video_banner_image = e.event_home_banner = DEFAULT_IMAGE.IMAGE_1;
            }
            e.cId = e.collection_ids && e.collection_ids.length > 0 ? e.collection_ids : 0;
            e.url = "network-market/overviewProduct/" + e.id + "/" + e.cId;
            productList.push(e);
            e.removeFromDrop = true;
          })
          this.bannerList = this.bannerList.concat(productList);
        }

        //NFT filtering starts here
        if (this.eventList.nft && this.eventList.nft.length > 0) {
          let nftList = [];
          this.eventList.nft.forEach(e => {
            if(e['number_of_copies_for_sale']>0 
            && e['created_by'] && e['wallet_id'] && e['created_by'] == e['wallet_id']
            && e['creator_copies']>0
            && e['drop_start_date_time'] && e['drop_start_date_time']!= 'null'
            && e['drop_end_date_time'] && e['drop_end_date_time']!='null'){  // Allow only if drop dates and min of 1 copy are present 
              e['isEvent'] = "nft";
              e['organization_name'] = e['stream_video_title'] = e.name;
              e['org_publish_date_time'] = e.saleStartTime;
              e['expected_end_date_time'] = e.saleEndTime;
              e['expected_end_date_time_formated'] = e.saleEndTime.replaceAll('-', '/');
              e['event_home_banner'] = e['video_banner_image'] =  e['organization_logo'] = e['links'][0]['thumbnail']?e['links'][0]['thumbnail']:e.links[0]['banner'];
              e['cId'] = e['collection_id'];
              e['url'] = "nft/product/overview/" + e.id;
              e['drop_start_date_time'] = e['drop_start_date_time'];
              e['drop_end_date_time'] = e['drop_end_date_time'];
              e['organization_name'] =  e['collection_name'];
              e['publish'] = 1;
              e['removeFromDrop'] = true;
              nftList.push(e);
              
            }
          })
          this.bannerList = this.bannerList.concat(nftList);
        }
        this.bannerList.splice(0, 0, { isEvent: 'upcoming' });
        if (this.myListResp && this.myListResp.length > 0 && this.bannerList.length > 0) {
          this.myListResp.forEach(list => {
            this.bannerList.forEach((event, index) => {
              if (Number(event.id) == Number(list.stream_video_id) && list.ticket_ids.length>0) {
                this.bannerList[index].isTicketPurchased = true;
                this.bannerList[index].ticket_key = list.ticket_key;
              }
            });
          });
        }
        if (this.bannerList.length > 1) {
          this.selectedIndex = 1;
        }
        this.isLoadingEvent = true;
        if (this.eventList.channels && this.eventList.channels.length > 0) {
          this.eventList.channels.forEach(e => {
            e.name = e.performer_details.performer_display_name;
            e.logo = e.performer_details.performer_profile_pic ? e.performer_details.performer_profile_pic : DEFAULT_IMAGE.IMAGE_1;
            e.video_banner_image = e.performer_details.performer_profile_banner ? e.performer_details.performer_profile_banner : DEFAULT_IMAGE.IMAGE_2;
            e.isEvent = "channels";
            if (e.performer_details.performer_bio) {
              e.performer_bio = (e.performer_details.performer_bio.length > 150) ? e.performer_details.performer_bio.substring(0, 150) + "..." : e.performer_details.performer_bio;
            }
          });
        }
        if (this.eventList && this.eventList.festivals) {
          this.eventList.festivals.forEach(el => {
            if (el.stream_info.media_files) {
              let media_files = JSON.parse(el.stream_info.media_files);
              Object.keys(media_files).forEach(element => {
                el[element] = media_files[element];
              });
            }
            el.video_thumbnail_image = el.stream_info.video_thumbnail_image
            el.isEvent = 'festivals'
            el.event_home_banner = el.video_thumbnail_image
          });
        }
        this.channelarray.forEach(element => {
          element.event_home_banner = element.org_info.channel_logo ? element.org_info.channel_logo : element.org_info.organization_logo;
          element.video_thumbnail_image = element.video_banner_image;
          element.channel_banner_img = element.org_info.channel_banner ? element.org_info.channel_banner : element.org_info.organization_logo;
        });
        // this.selectedChannel = this.channelarray[0];
        this.dispalyChannel(this.channelarray[0]);
        this.sliderArray = [
          {
            title: "Channels",
            is_vertical: false,
            dataArray: this.channelarray
          },
        ];
      }
      this.bannerList = this.bannerList.map((banner) => {
        let list = banner;
        list['banner_dates'] = this.formatDate(banner.org_publish_date_time, banner.expected_end_date_time_formated)
        return list
      })
      this.bannerList.forEach((bannerListElement, listIndex) => {
        this.displayMultipleTime.push(
          { 'message': '', 'timerTime': 0, 'showTimer': false, 'displayTimer': null, days: null, hours: null, minutes: null, seconds: null, removeFromDrop: true, 'saleEnd': false, 'saleStart': false, 'eventStart': false }
        )
      });

      //this.clearTimer(1);
      this.startTimer(1);
      this.calculateMultipleTimes(1);

    }).catch(error => {
      console.log("banner list - error", error);
      this.isLoadingEvent = false;
      this.ngxLoader.stop();
    });
  }

  outsideClick(event) {
    if (event.target.outerText != "Share Event" && event.target.id != "shareEventIcon") {
      // this.isShown = false;
    }
  }

  isShown: boolean = false;
  toggleShow() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Share-clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Share-clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
    }
    this.commanService.sendTriggeredEvent(data);
    this.isShown = true;
  }
  shareClose() {
    this.isShown = false;
  }
  displayTimerIndex = 0;
  calculateMultipleTimes(index) {
    // let localEventStartDate = moment.utc(this.bannerList[index].org_publish_date_time).local().format("YYYY-MM-DD HH:mm:ss");
    let todayLocalTime = moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
    this.todayDate = moment.utc(todayLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
    this.displayTimerIndex = index;
    let event_start_time = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
    let localEventStartDate = moment.utc(event_start_time).local().format("YYYY-MM-DD HH:mm:ss");
    let event_end_date = moment.utc(this.bannerList[index].expected_end_date_time).local().format("YYYY-MM-DD HH:mm:ss");
    let localEventEndDate = moment.utc(event_end_date).local().format("YYYY-MM-DD HH:mm:ss");
    let localSalesStartDate, localSalesEndDate;
    if (this.bannerList[index].isEvent == "upcoming") {
      let sale_start_time = moment.utc(this.bannerList[index].sale_start_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      localSalesStartDate = moment.utc(sale_start_time).local().format("YYYY-MM-DD HH:mm:ss");
      let sale_end_time = moment.utc(this.bannerList[index].sale_end_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      localSalesEndDate = moment.utc(sale_end_time).local().format("YYYY-MM-DD HH:mm:ss");
    }
    // Allow only first time or while changing the condition 
    if (this.displayMultipleTime[index]['timerTime'] == 0 && this.bannerList[index].isEvent == "upcoming") {
      if (moment(localSalesStartDate).diff(moment(this.todayDate), 'seconds') > 0 && !this.displayMultipleTime[index]['saleStart']) {       // If sales not yet started
        this.displayMultipleTime[index]['message'] = "Sale starts in ...";
        this.displayMultipleTime[index]['timerTime'] = moment(localSalesStartDate).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
        this.displayMultipleTime[index]['saleStart'] = true;
      } else if (moment(localEventStartDate).diff(moment(this.todayDate), 'seconds') > 0 && !this.displayMultipleTime[index]['eventStart']) {
        this.displayMultipleTime[index]['message'] = "Event starts in ...";
        this.displayMultipleTime[index]['timerTime'] = moment(localEventStartDate).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
        this.displayMultipleTime[index]['eventStart'] = true;
      } else if (moment(localSalesEndDate).diff(moment(this.todayDate), 'seconds') > 0 && !this.displayMultipleTime[index]['saleEnd']) {
        this.displayMultipleTime[index]['message'] = "Sale ends in ..."
        this.displayMultipleTime[index]['timerTime'] = moment(localSalesEndDate).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
        this.displayMultipleTime[index]['saleEnd'] = true;
      } else {
        this.displayMultipleTime[index]['message'] = "Event ends in ...";
        this.displayMultipleTime[index]['timerTime'] = moment(localEventEndDate).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
      }
    } else if (this.displayMultipleTime[index]['timerTime'] == 0 && (this.bannerList[index].isEvent == "albums" || this.bannerList[index].isEvent == "product")) {
      // Publish date
      let publishLocalTime = moment.utc(this.bannerList[index].org_publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let localPublish = moment.utc(publishLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
      // end date
      let expected_local_time = moment.utc(this.bannerList[index].expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let local_end_time = moment.utc(expected_local_time).local().format("YYYY-MM-DD HH:mm:ss");
      // this.totalSeconds = moment(localPublish).diff(moment(localToday), 'seconds'); 
      if (moment(localPublish).diff(moment(this.todayDate), 'seconds') > 0) {
        this.displayMultipleTime[index]['message'] = this.bannerList[index].isEvent == "albums" ? "Album drops starts in ..." : "Drop starts in ...";
        this.displayMultipleTime[index]['timerTime'] = moment(localPublish).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
      } else {
        this.displayMultipleTime[index]['message'] = this.bannerList[index].isEvent == "albums" ? "Album drop ends in ..." : "Drop ends in ...";
        this.displayMultipleTime[index]['timerTime'] = moment(local_end_time).diff(moment(this.todayDate), 'seconds');
        this.displayMultipleTime[index]['showTimer'] = true;
      }
    }
    else if (this.displayMultipleTime[index]['timerTime'] == 0 && (this.bannerList[index].isEvent == "nft")) { 

      let nft_sale_start_time = moment.utc(this.bannerList[index].saleStartTime, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let localNFTSalesStartDate = moment.utc(nft_sale_start_time).local().format("YYYY-MM-DD HH:mm:ss");
      let localNFTSalesStartDateInSeconds = (moment(localNFTSalesStartDate, "YYYY-MM-DD HH:mm:ss").local().valueOf())/1000;

      let nft_sale_end_time = (this.bannerList[index].saleEndTime && this.bannerList[index].saleEndTime != "null") ? moment.utc(this.bannerList[index].saleEndTime, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal):null;
      let localNFTSalesEndDate = nft_sale_end_time ? moment.utc(nft_sale_end_time).local().format("YYYY-MM-DD HH:mm:ss"):null;
      let localNFTSalesEndDateInSeconds = localNFTSalesEndDate ? (moment(localNFTSalesEndDate, "YYYY-MM-DD HH:mm:ss").local().valueOf())/1000:null;

      let nft_drop_start_time = moment.utc(this.bannerList[index].drop_start_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let localNFTDropStartDate = moment.utc(nft_drop_start_time).local().format("YYYY-MM-DD HH:mm:ss");
      let localNFTDropStartDateInSeconds = (moment(localNFTDropStartDate, "YYYY-MM-DD HH:mm:ss").local().valueOf())/1000;

      let nft_drop_end_time = moment.utc(this.bannerList[index].drop_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let localNFTDropEndDate = moment.utc(nft_drop_end_time).local().format("YYYY-MM-DD HH:mm:ss");
      let localNFTDropEndDateInSeconds = (moment(localNFTDropEndDate, "YYYY-MM-DD HH:mm:ss").local().valueOf())/1000;

      let currentDateInSeconds: any = moment(this.todayDate).valueOf()/1000;
      
      if(this.bannerList[index]['saleType']=='auction' && this.bannerList[index].drop_start_date_time && this.bannerList[index].drop_end_date_time){
        // Sale and drop dates are present
        if(this.bannerList[index].saleStartTime && this.bannerList[index].saleEndTime && this.bannerList[index].saleStartTime!= "null" && this.bannerList[index].saleEndTime !="null"){       
          if(localNFTSalesStartDateInSeconds - currentDateInSeconds>=0){
            this.displayMultipleTime[index]['message'] = "Sale starts in ...";
            this.displayMultipleTime[index]['timerTime'] =  localNFTSalesStartDateInSeconds - currentDateInSeconds // Take sales end date time
            this.displayMultipleTime[index]['showTimer'] = true;
          }
          else if(localNFTSalesStartDateInSeconds - currentDateInSeconds<0){ // If sales started
            if(nft_sale_end_time){
              this.displayMultipleTime[index]['message'] = "Sale ends in ...";
              this.displayMultipleTime[index]['timerTime'] =  localNFTSalesEndDateInSeconds-currentDateInSeconds // Take sales end date time
              this.displayMultipleTime[index]['showTimer'] = true;
            }else{
              this.displayMultipleTime[index]['message'] = "Drop ends in ...";
              this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds  // Take sales end date time
              this.displayMultipleTime[index]['showTimer'] = true;
            }
          }
          if(currentDateInSeconds>localNFTDropEndDateInSeconds){     // Drop ended but present on page
              this.displayMultipleTime[index]['message'] = "Sale ends in ...";
              this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds;
              this.displayMultipleTime[index]['showTimer'] = true;
          }
        }else{
          // Drop dates are present and sale dates are not present
          if(localNFTDropEndDateInSeconds>currentDateInSeconds){
            this.displayMultipleTime[index]['message'] = "Drop ends in ...";
            this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds;
            this.displayMultipleTime[index]['showTimer'] = true;
          }else{
            this.displayMultipleTime[index]['message'] = "Drop ends in ...";
            this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds;
            this.displayMultipleTime[index]['showTimer'] = true;
          }
        }
      }else{
        if(localNFTDropEndDateInSeconds>currentDateInSeconds){
          this.displayMultipleTime[index]['message'] = "Drop ends in ...";
          this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds;
          this.displayMultipleTime[index]['showTimer'] = true;
        }else{
          this.displayMultipleTime[index]['message'] = "Drop ends in ...";
          this.displayMultipleTime[index]['timerTime'] =  localNFTDropEndDateInSeconds-currentDateInSeconds;
          this.displayMultipleTime[index]['showTimer'] = true;
        }
      }

  
    }
    
  }

  // getSignedURL(filename, cb) {
  //   this.ngxLoader.start();
  //   let url = filename.split("/");
  //   let signeURL = url.slice(-3).join("/");
  //   let data = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-api-key": environment.AWS_Cognito.X_Api_Key,
  //     },
  //     response: true,
  //     body: { "name": signeURL, "type": "get" }
  //   }
  //   API.post(environment.AWS_Cognito.apiName,  CONST_AWS_API.GET_URL, data).then(response => {
  //     if (response) {
  //       console.log(response);
  //       // signeURL = response.data.signed_url;
  //       this.ngxLoader.stop();
  //       cb(response.data.signed_url);
  //     }
  //   }).catch(error => {
  //     cb(signeURL);
  //     this.ngxLoader.stop();
  //     this.toastr.error("Unable to play the file");
  //     console.log(error);
  //   });
  // }

  startTimer(index){
    let realTimeCurrentDate = moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal); // If time passes and goes to next day
    let formattedRealTimeCurrentDate = moment.utc(realTimeCurrentDate).local().format("YYYY-MM-DD HH:mm:ss");
    let splitFormattedRealTimeCurrentDate = formattedRealTimeCurrentDate.split(' ')
    if(splitFormattedRealTimeCurrentDate[0] != this.todayDate.split(' ')[0]){
      this.todayDate = formattedRealTimeCurrentDate;
      if(this.bannerList.length>1){
        index = index-1;
      }
    }
    this.displayMultipleTime[index].displayTimer = setInterval(() => {
      if (this.displayMultipleTime[index] && this.displayMultipleTime[index]['timerTime'] && this.displayMultipleTime[index]['timerTime'] > 0) {
        this.displayMultipleTime[index]['days'] = Math.floor(this.displayMultipleTime[index]['timerTime'] / (3600 * 24));
        this.displayMultipleTime[index]['hours'] = Math.floor(this.displayMultipleTime[index]['timerTime'] % (3600 * 24) / 3600);
        this.displayMultipleTime[index]['minutes'] = Math.floor(this.displayMultipleTime[index]['timerTime'] % 3600 / 60);
        this.displayMultipleTime[index]['seconds'] = Math.floor(this.displayMultipleTime[index]['timerTime'] % 60);
        this.displayMultipleTime[index]['timerTime'] = this.displayMultipleTime[index]['timerTime'] - 1;
      } else {
        this.displayMultipleTime[index]['days'] = 0;
        this.displayMultipleTime[index]['hours'] = 0;
        this.displayMultipleTime[index]['minutes'] = 0;
        this.displayMultipleTime[index]['seconds'] = 0;
        this.displayMultipleTime[index]['timerTime'] = 0;
        if (this.displayMultipleTime[index]['message'] == "Sale ends in ..." || this.displayMultipleTime[index]['message'] == "Album drop ends in ..." || this.displayMultipleTime[index]['message'] == "Drop ends in ...") {
          let removedbanner = this.bannerList.filter(data => data.id != this.bannerList[index].id);
          this.bannerList=removedbanner;
          this.displayMultipleTime.splice(index, 1)
          index = index - 1;
          this.selectedIndex = this.selectedIndex - 1;
          this.calculateMultipleTimes(index);
        }
        else{
          this.calculateMultipleTimes(index);
        }
      }
    }, 1000)
    this.displayTimerIndex = index;
  }

  getSignedURL(filename, cb) {
    this.ngxLoader.start();
    let url = filename.split("/");
    let signeURL = url.slice(-3).join("/");
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
      },
      response: true,
      body: { "name": signeURL, "type": "get" }
    }
    API.post(environment.AWS_Cognito.apiName,  CONST_AWS_API.GET_URL, data).then(response => {
      if (response) {
        console.log(response);
        // signeURL = response.data.signed_url;
        this.ngxLoader.stop();
        cb(response.data.signed_url);
      }
    }).catch(error => {
      cb(signeURL);
      this.ngxLoader.stop();
      this.toastr.error("Unable to play the file");
      console.log(error);
    });
  }
  leftScroll(data) {
    // this.divid = 'tags'+ data;
    document.getElementById('tags' + data).scrollLeft -= 2000;
  }
  rightScroll(data) {
    // let scroll =  document.getElementById('gener'+data).scrollLeft += 30;
    document.getElementById('tags' + data).scrollLeft += 2000;
  }
  isShowFirstVideo(i) {
    if (i == 0) {
      return true;
    }
    return false;
  }
  goToAlbum(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Explore-clicked - ${userId}`)
    const payload = {
      actionType: "network",
      metaData: {
        title: "Explore-clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
    }
    this.commanService.sendTriggeredEvent(payload);
    if (data.vod_video_audio === "audio") {
      this.router.navigate(["/" + data.channel_name + "/album/audio/" + data.slug]);
    }
    else {
      this.router.navigate(["/" + data.channel_name + "/album/video/" + data.slug]);
    }
  }

  goToPastEvent(data) {
    this.router.navigate([`${data.channel_name}/` + "event/" + data.slug])
  }

  goToEventReg(event) {
    if (event.isEvent == "upcoming" && event.slug) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "event",
        metaData: {
          title: "Get Tickets-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
      }
      this.commanService.sendTriggeredEvent(data);
      this.router.navigateByUrl(`${event?.channel_name}/event/${event.slug}`);
    } else if (event.isEvent == "channels" && event.channel_name) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "network",
        metaData: {
          title: "Network-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
      this.commanService.icWebpageSettingsData = {};
      this.commanService.perfomerInfoData = {};
      this.commanService.subscribePayedInfoData = {};
      this.router.navigate([`/${event.channel_name}`])
        .then(() => {
          window.location.reload();
        });
    } else if (event.isEvent == "festivals" && event.stream_info.slug) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "network",
        metaData: {
          title: "Network-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
      this.router.navigateByUrl(`${event?.channel_name}/event/${event.stream_info.slug}`);
    } else if (event.isEvent == "otherWebsite" && event.link) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      window.open(event.link, "_blank");
      const data = {
        actionType: "event",
        metaData: {
          title: "Network-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
    } else if (event.isEvent == "albums") {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      let name = event?.network_name ? event?.network_name : event?.channel_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "network",
        metaData: {
          title: "Network-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
      this.router.navigate(["/" + name + "/album/" + event.vod_video_audio + "/" + event.slug]);
    } else if (event.isEvent == "product") {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "product",
        metaData: {
          title: "Product-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
      this.router.navigate([event.url]);
    } else if(event.isEvent == "nft"){
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Get Tickets-clicked - ${userId}`)
      const data = {
        actionType: "nft",
        metaData: {
          title: "NFT-clicked",
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
        },
        organizationId: event?.organization_id || null,
        clickAction: `event-type`
        
      }
      this.commanService.sendTriggeredEvent(data);
      this.router.navigate([event['url']]);
    }
  }
  
  selectedChannel: any;
  enterChannel() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Enter Channel-clicked - ${userId}`)
    console.log("Selected Channel:", this.selectedChannel);
    console.log("Slug Info:", this.commanService.slugInfo);
    console.log("performer info data:", this.commanService.perfomerInfoData);
    const data = {
      actionType: "network",
      metaData: {
        title: "Network-clicked",
        timeStamp: new Date().toISOString(),
      },
      organizationId: this.selectedChannel?.organization_id || null,
      clickAction:'network-selected'
    }

    this.commanService.sendTriggeredEvent(data);
    this.commanService.icWebpageSettingsData = {};
    this.commanService.perfomerInfoData = {};
    this.commanService.subscribePayedInfoData = {};
    this.router.navigate([`/${this.selectedChannel.channel_name}`]).then(() => {
      //window.location.reload();
    });
  }

  dispalyChannel(event, from?) {
    this.selectedChannel = event;
    if (from && from == 'mobile') {
      this.enterChannel();
    }
  }
  formatDate(startDate, endDate) {
    let startMonth = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    let endMonth = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    let formattedStartDate = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    let formattedEndDate = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    if (startMonth === endMonth && formattedStartDate == formattedEndDate) {
      return `${startMonth} ${formattedStartDate}`
    } else if (startMonth == endMonth && formattedStartDate != formattedEndDate) {
      return `${startMonth} ${formattedStartDate}-${formattedEndDate}`
    } else {
      return `${startMonth} ${formattedStartDate}- ${endMonth} ${formattedEndDate}`
    }

  }

  imageScroll() {
    (function HorizontalScrolling() {
      function wheelHandler(element, event) {
        const toLeft = event.deltaY < 0 && element.scrollLeft > 0
        const toRight = event.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth
        if (toLeft || toRight) {
          event.preventDefault()
          event.stopPropagation()
          element.scrollBy({ left: event.deltaY * 12 })
        }
      }
      const targets = document.querySelectorAll('#event-container,#past-event-container')
      targets.forEach(element => element.addEventListener('wheel', event => wheelHandler(element, event)))
    })()
  }

  navigateToCharity(charity) {
    this.router.navigate(['/charity', charity])
  }

  handleVisibilityChange = () => {
    console.log(">>>>",document.hidden,this.isLoggedIn,this.walletID);
    if (!document.hidden && this.isLoggedIn && !this.walletID) {
      console.log("User is back on this tab!");
      window.location.reload();
    }
  };

  ngOnDestroy() {
    // document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    this.storageService.deleteItem('eventInfo');
    if (this.myListInfoSubscription)
      this.myListInfoSubscription.unsubscribe();
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
    if (this.displayTime) {
      clearInterval(this.displayTime);
    }

    this.displayMultipleTime.forEach((element, index) => {
      if (this.displayMultipleTime[index]['displayTimer']) {
        clearInterval(this.displayMultipleTime[index]['displayTimer']);
      }
    });
  }

  GetInTouch = () => {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Get In Touch-clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Get In Touch-clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService.slugInfo?.organizationId || null,
    }
    this.commanService.sendTriggeredEvent(data);
  };
}
